import * as o from "react";
import t from "../lib/IconBase.es.js";
import c from "../defs/WarningOctagon.es.js";
const n = o.forwardRef((a, r) => /* @__PURE__ */ o.createElement(t, { ref: r, ...a, weights: c }));
n.displayName = "WarningOctagonIcon";
const m = n;
export {
  m as WarningOctagon,
  n as WarningOctagonIcon
};
